import { useState, useEffect } from "react";

/**
 * Custom hook to manage employee selection state
 * @param {Array} filteredEmployees - List of filtered employees
 * @returns {Object} Selection state and handlers
 */
export const useEmployeeSelection = (filteredEmployees) => {
  const [selectedEmployees, setSelectedEmployees] = useState([]);

  // Clear selected employees if they're no longer in filtered list
  useEffect(() => {
    const filteredIds = filteredEmployees.map((emp) => emp.id);
    setSelectedEmployees((prev) => prev.filter((id) => filteredIds.includes(id)));
  }, [filteredEmployees]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const selectableEmployeeIds = filteredEmployees
        .filter((emp) => (emp.evidenceCount || 0) > 0)
        .map((emp) => emp.id);
      setSelectedEmployees(selectableEmployeeIds);
    } else {
      setSelectedEmployees([]);
    }
  };

  const handleSelectEmployee = (employeeId) => {
    setSelectedEmployees((prev) => {
      if (prev.includes(employeeId)) {
        return prev.filter((id) => id !== employeeId);
      } else {
        return [...prev, employeeId];
      }
    });
  };

  const clearSelection = () => {
    setSelectedEmployees([]);
  };

  // Only count selectable employees (those with evidence)
  const selectableEmployees = filteredEmployees.filter(
    (emp) => (emp.evidenceCount || 0) > 0
  );

  const isAllSelected =
    selectableEmployees.length > 0 &&
    selectedEmployees.length === selectableEmployees.length;

  const isSomeSelected =
    selectedEmployees.length > 0 &&
    selectedEmployees.length < selectableEmployees.length;

  return {
    selectedEmployees,
    handleSelectAll,
    handleSelectEmployee,
    clearSelection,
    isAllSelected,
    isSomeSelected,
  };
};
